import { IApplicationState } from '../../types/redux';

export const getSubtitles = (state: IApplicationState) => {
  return state.offersData.seo?.subtitles;
};
